// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_transportation_network_ui_styles" + "." + "13101869" + ".chunk.css";
};